import React, { useState } from 'react';
import { bool, func } from 'prop-types';

import { FormattedMessage } from '../../../util/reactIntl';
import Modal from '../../Modal/Modal';
import { PrimaryButton } from '../../Button/Button';
import SkeletonBack from '../../Skeleton/Back';
import SkeletonFront from '../../Skeleton/Front';

// Reuses TattoInquiryForm's toggle/skeleton styling so the flash booking
// flow's body-part step looks identical to the portfolio quote flow's.
import css from '../TattoInquiryForm/TattoInquiryForm.module.css';

const FlashBodyPartModal = props => {
  const { isOpen, onClose, onConfirm, onManageDisableScrolling, submitInProgress } = props;
  const [isBack, setIsBack] = useState(false);
  const [choosenPath, setChoosenPath] = useState({});

  const handleSkeletonClick = key => {
    setChoosenPath(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const hasSelection = Object.values(choosenPath).some(Boolean);

  return (
    <Modal
      id="FlashBodyPartModal"
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <p className={css.center}>
        <FormattedMessage id="requestInquiry.progressFourHeading" />
      </p>

      <div className={css.wrapper}>
        <div
          className={`${css.toggleContainer} ${isBack ? css.backActive : css.frontActive}`}
        >
          <button
            type="button"
            onClick={() => setIsBack(false)}
            className={`${css.toggleButton} ${!isBack ? css.active : ''}`}
          >
            <FormattedMessage id="TattooInquiryForm.Front" />
          </button>
          <button
            type="button"
            onClick={() => setIsBack(true)}
            className={`${css.toggleButton} ${isBack ? css.active : ''}`}
          >
            <FormattedMessage id="TattooInquiryForm.Back" />
          </button>
          <div
            className={`${css.toggleIndicator} ${isBack ? css.toggleRight : css.toggleLeft}`}
          />
        </div>
      </div>

      <div className={css.contentWrapper}>
        <div className={`${css.content} ${isBack ? css.flip : ''}`}>
          {isBack ? (
            <SkeletonBack choosenPath={choosenPath} handleSkeletonClick={handleSkeletonClick} />
          ) : (
            <SkeletonFront choosenPath={choosenPath} handleSkeletonClick={handleSkeletonClick} />
          )}
        </div>
      </div>

      <PrimaryButton
        className={css.submitButton}
        type="button"
        onClick={() => onConfirm(choosenPath)}
        disabled={!hasSelection}
        inProgress={submitInProgress}
      >
        <FormattedMessage id="FlashBodyPartModal.continueButton" />
      </PrimaryButton>
    </Modal>
  );
};

FlashBodyPartModal.defaultProps = {
  submitInProgress: false,
};

FlashBodyPartModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onConfirm: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  submitInProgress: bool,
};

export default FlashBodyPartModal;
